import React, { Component } from 'react';
import * as models from 'Models/index';

import styled from 'styled-components';

import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PostImage from './PostImage';

export const MyComponent = styled.div`
  color: ${props => props.theme.colors.main};
`;

const StyledPost = styled.div`
  width: 320px;
  height: 320px;
  border: 2px solid black;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
`;

const PostInfo = styled.div`
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  justify-content: space-between;
  color: #eeeeee;
  font-size: smaller;
  padding: 10px;
`;

const PostAuthor = styled.div`
  text-align: left;

  a {
    text-decoration: none;
    color: white;
  }
`;

const PostAge = styled.div`
  text-align: center;
`;

const PostLikes = styled.div`
  text-align: right;
`;

export const dummyPost: models.Post = {
  id: 18002297401211563,
  type: models.PostType.Image,
  ownerId: 1686306061,
  permaLink: 'https://www.instagram.com/p/Bx9BkVgHWgb/',
  content:
    'こんにちは。<br>お返事前にごめんなさい。<br><br>週末の朝ごはん。<br><br>休日の朝ごはんは和食が多いですが、<br>金曜日に行ったパン屋さんで、食パン、レタス、大山のむヨーグルトを買ってきたので洋食にしました😊🍳 ・<br>・<br><br>フライパンは  <a class="notranslate" href="/royaldesign.jp/">@royaldesign.jp</a> さん の ティファール× ジェイミーオリバーさんのもの。以前 <a class="notranslate" href="/paramegu/">@paramegu</a> ちゃんがつかってて、いいなぁと思って私もお迎えしました😌<br><br>目玉焼きもいつもより綺麗に焼けるような気がします✨<br><br>そして、イッタラのレンピも安くなってたので、いっしょにお迎えしました。アイスコーヒーやヨーグルト、ビール、ジュース、デザートなど<br>なんでも合うのでお気に入りです✨<br><br>いつの間にか５月もあと少し。<br>今週もよろしくお願いします😊<br><br><a class="" href="/explore/tags/royaldesign/">#Royaldesign</a> <a class="" href="/explore/tags/ロイヤルデザイン/">#ロイヤルデザイン</a> <a class="" href="/explore/tags/イッタラ/">#イッタラ</a> <a class="" href="/explore/tags/ittala/">#ittala</a> <a class="" href="/explore/tags/レンピ/">#レンピ</a> <a class="" href="/explore/tags/ティファール/">#ティファール</a> <a class="" href="/explore/tags/ジェイミーオリバー/">#ジェイミーオリバー</a> <a class="" href="/explore/tags/フライパン/">#フライパン</a> <a class="" href="/explore/tags/北欧/">#北欧</a> <a class="" href="/explore/tags/kitchen/">#Kitchen</a> <a class="" href="/explore/tags/台所/">#台所</a> <a class="" href="/explore/tags/マイホーム/">#マイホーム</a> <a class="" href="/explore/tags/おうちカフェ/">#おうちカフェ</a> <a class="" href="/explore/tags/パン/">#パン</a> <a class="" href="/explore/tags/目玉焼き/">#目玉焼き</a><a class="" href="/explore/tags/アイスコーヒー/">#アイスコーヒー</a> <a class="" href="/explore/tags/のむヨーグルト/">#のむヨーグルト</a> <a class="" href="/explore/tags/ウインナー/">#ウインナー</a> <a class="" href="/explore/tags/器/">#器</a> <a class="" href="/explore/tags/食器/">#食器</a>  <a class="" href="/explore/tags/クチポール/">#クチポール</a> <a class="" href="/explore/tags/食パン/">#食パン</a><br><br>https://royaldesign.jp/',
  owner: {
    id: 1686306061,
    username: 'hugohallqvist',
    fullName: 'Hugo Hallqvist',
    profilePicHash: '',
    profilePicUrlOrig: ''
  },
  likeCount: 55,
  commentsCount: 128,
  mediaUrl: '',
  mediaUrlOrig:
    'https://scontent.xx.fbcdn.net/v/t51.2885-15/56291103_165775894428105_8327744218822117850_n.jpg?_nc_cat=110&_nc_oc=AQl8Db-zb37Uagx3HsIO2Fgu4nEhcIzzqNkTQD-6uRFCYFXZH6slm_n5ZlghtuNBe9g&_nc_ht=scontent.xx&oh=b100507d6975e34e654fa37e72277ec1&oe=5DB7B15D',
  created: new Date(2019, 5, 14),
  media: [{ n: 'p/18130473514027668_0' }]
};
export const dummyPosts: models.Post[] = [
  { ...dummyPost, ...{ media: [{ n: 'p/17841547432024309_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17841648691000197_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842023097973020_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842061339011472_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842092041021829_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842181300031783_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842268167976075_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842278542031869_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842389787837874_0' }] } },
  { ...dummyPost, ...{ media: [{ n: 'p/17842433725708659_0' }] } },
]

interface IState {
  pageNr: number;
}

interface PostProps {
  post: models.Post;
  apiUrl?: string;
  stylePostComponent?: boolean;
  className?: string;
}

class Post extends Component<PostProps, IState> {
  state: IState = {
    pageNr: 0
  };

  calcDiff() {
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    var firstDate = new Date();
    var secondDate = this.props.post.created;

    var diffDays = Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)

    //console.log("calcDiff", firstDate, secondDate, diffDays, firstDate.getTime() - secondDate.getTime());

    if (diffDays >= 1) return `${Math.round(diffDays)} days`;
    var hours = diffDays * 24;
    if (hours >= 1) return `${Math.round(hours)} hours`;
    var minutes = hours * 60
    if (minutes >= 1) return `${Math.round(minutes)} minutes`;
    var seconds = minutes * 60;

    return `${Math.round(seconds)} seconds`;
  }

  getMediaUrl() {
    var nr = this.state.pageNr;
    var p = this.props.post;
    if (!p.media)
      return null;
    var key = p.media[nr].n;
    return `${this.props.apiUrl}Post/GetImage?key=${key}`;
  }

  renderInner() {
    const post = this.props.post;
    const owner = post.owner || { username: "" };

    return (
      <>
        <PostImage post={post} apiUrl={this.props.apiUrl} />
        <PostInfo>
          <PostAuthor>
            <FontAwesomeIcon icon={faInstagram} />
            <span>
              <a href={post.permaLink} target="_igtarget">
                {' '}
                {owner.username}
              </a>
            </span>
          </PostAuthor>

          <PostAge>
            <span>{this.calcDiff()}</span>
          </PostAge>

          <PostLikes>
            <FontAwesomeIcon icon={faHeart} />
        &nbsp;<span>{post.likeCount} </span>
          </PostLikes>
        </PostInfo>
      </>
    );
  }

  render() {
    if (this.props.stylePostComponent != false) {
      return (
        <StyledPost>
          {this.renderInner()}
        </StyledPost>
      )
    }
    return (<div className={this.props.className}>
      {this.renderInner()}
    </div>);
  }
}

export default Post;
